export default class Navigation {
  constructor(dom) {
    this.dom = dom;
  }
  init() {
    const navBtn = this.dom.querySelector(".btn-nav");
    const navPanel = this.dom.querySelector(".nav-panel");
    navBtn.addEventListener("pointerup", () => {
      navPanel.classList.toggle("expand");
      navBtn.classList.toggle("expand");
    });

    const navPanelOverlay = this.dom.querySelector(".nav-panel .overlay");
    if (navPanelOverlay) {
      navPanelOverlay.addEventListener("pointerup", () => {
        const navBtn = this.dom.querySelector(".btn-nav");
        const navPanel = this.dom.querySelector(".nav-panel");
        navPanel.classList.remove("expand");
        navBtn.classList.remove("expand");
      });
    }

    const navGroups = this.dom.querySelectorAll(".nav-group");
    navGroups.forEach((group) => {
      const expandIcon = group.querySelector(".icon-expand");
      expandIcon.addEventListener("pointerup", () => {
        group.classList.toggle("expanded");
      });
    });
  }
}
